import { useMemo } from 'react';
import { CatSkeleton } from 'blocks-nextjs/blocks-react/components/Skeleton';
import { Conditional } from '@cat-ecom/pcc-components';
import { ProductAvailabilityByDate } from 'components/product-availability';
import { InterimStoreAvailabilityType } from '../types';
import { HoseAssemblyDetails } from 'components/hose-assembly-details/hose-assembly-details';
import AvailabilityTitle from 'components/availability-wrapper/availability-title/availability-title';

const InterimStoreAvailablityTable = ({
  hideLabel,
  hoseAssemblyDetails,
  isLoading,
  isDeliveryEnabled,
  isPickupEnabled,
  availabilityToolTipMessage,
  sourcingDetails,
  shouldWrap,
  address,
  locale,
  hideToolTipIcon,
  availabilityByStoreLink
}: InterimStoreAvailabilityType) => {
  const formattedSourcingDetails = useMemo(() => {
    return sourcingDetails?.map((detail) => ({
      ...detail,
      availStoreList: detail.availStoreList.map((store) => ({
        ...store,
        quantityAvailable: Number(store.quantityAvailable)
      }))
    }));
  }, [sourcingDetails]);

  const hasData = sourcingDetails?.length > 0;

  const { hoseAssemblyIndicator, hoseAvailabilityLabel } =
    hoseAssemblyDetails || {};

  const renderAvailabilityTable = () => {
    return hasData ? (
      <>
        <AvailabilityTitle
          hideLabel={hideLabel}
          availabilityToolTipMessage={availabilityToolTipMessage}
          isDeliveryEnabled={isDeliveryEnabled}
          isPickupEnabled={isPickupEnabled}
          hideToolTipIcon={hideToolTipIcon}
        />
        {hoseAssemblyIndicator ? (
          <HoseAssemblyDetails hoseAvailabilityLabel={hoseAvailabilityLabel} />
        ) : (
          <>
            <ProductAvailabilityByDate
              sourcingDetails={formattedSourcingDetails}
              isCompact={false}
              shouldWrap={shouldWrap}
              address={address}
              locale={locale}
            />
            {availabilityByStoreLink}
          </>
        )}
      </>
    ) : null;
  };

  return (
    <div data-testid="interim-store-availability-table">
      <Conditional
        test={!isLoading}
        fallback={<CatSkeleton data-testid="loader-id" width="300px" />}
      >
        {renderAvailabilityTable()}
      </Conditional>
    </div>
  );
};

export default InterimStoreAvailablityTable;
